export class CESFPlace {
  static UNDEFINED = -1;
  static WC = 0;
  static DIAPER = 1;
  static SELF = 2;
}
